const TableFilterBar = ({
  searchValue = "",
  searchPlaceholder = "Search",
  onSearchChange,
  filters = null,
  actions = null,
  className = "",
}) => (
  <section className={`table-standard-top-bar ${className}`.trim()}>
    <div className="table-standard-top-bar-inner">
      <div className="flex gap-2 items-center flex-wrap flex-1 min-w-0">
        {onSearchChange && (
          <div className="search-input-wrapper">
            <i className="fas fa-search search-input-icon" aria-hidden />
            <input
              type="text"
              className="search-input"
              value={searchValue}
              placeholder={searchPlaceholder}
              onChange={(event) => onSearchChange(event.target.value)}
            />
          </div>
        )}
        {filters}
      </div>
      {actions ? (
        <div className="flex items-center shrink-0">{actions}</div>
      ) : null}
    </div>
  </section>
);

export default TableFilterBar;
